import {
  useOrganizationHistoryQuery,
  useOrganizationLogoQuery,
  useOrganizationQuery,
} from '@common/cache';
import { useContext, useEffect, useState } from 'react';
import { AdminPanelDrawerContext } from '@views/pages/Admin/context';

interface IUseOrganizationItemProps {
  id: string;
  handleClose: () => void;
}

const historyTabIndex = '2';

export const useOrganizationItem = ({
  id,
  handleClose,
}: IUseOrganizationItemProps) => {
  const [historyPage, setHistoryPage] = useState(1);
  const {
    isFormClean,
    handleClear,
    handleCloseTrigger,
    tabIndex,
    handleTriggerChangeTab,
    triggerClose,
  } = useContext(AdminPanelDrawerContext);

  const organization = useOrganizationQuery({
    organization_id: id,
  });

  const organizationHistory = useOrganizationHistoryQuery({
    organization_id: id,
    page: historyPage,
    limit: 100,
    enabled: historyTabIndex === tabIndex,
  });

  const fetchedLogo = useOrganizationLogoQuery({
    organization_id: id,
  });

  useEffect(() => {
    if (isFormClean && triggerClose) {
      handleClose();
      handleClear();
    }
  }, [isFormClean, triggerClose]);

  return {
    historyPage,
    setHistoryPage,
    organization,
    tabIndex,
    handleTriggerChangeTab,
    organizationHistory: organizationHistory.data,
    fetchedLogo,
    handleCloseTrigger,
    historyTabIndex,
  };
};
